import { html } from "lit-element";
import { textFormat } from "../../../styles/icons";
import { StatefulModule } from "../ModuleBase/ModuleMetadata";
import '../../../elements/color-picker.js';

export class DrawTextModule extends StatefulModule {
	get MainTb() {
		return {
			value: "text",
			icon: textFormat,
			text: "text"
		};
	}

	Activate() {
		this.canvas.defaultCursor = "crosshair";
		this.canvas.on("mouse:down", this.__drawText);
		this.canvas.on("text:event:changed", this.__textObjectChanged);
		return this;
	}

	Deactivate() {
		this.canvas.off("mouse:down", this.__drawText);
		this.canvas.off("text:event:changed", this.__textObjectChanged);
	}

	render() {
		return html`
          
         
            `;
	}

	RenderSettings(obj, closeFunc) {
		const currentSettings = obj.moduleState;
		let tempSize = currentSettings.fontSize;

		let tempColor = currentSettings.fill
		let tempText = currentSettings.text

		if (tempText != obj.text) {
			tempText = obj.text;
		}

		const applyFunc = () => {
			this.applyNewSettings(obj, tempSize, tempColor, tempText);
			closeFunc();
		};

		return html`
            <style>
                .title {
                    font-size: x-large;    
                    font-weight: bold;
                    margin-bottom: 20px;
                }
                .button-box {
                    display: flex;
                    margin-top: 20px;
                }
                           .cPick{
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    color: var(--secondary-color-variant1);
                }
            </style>

            <div class="title">Text settings</div>    
            <div> 
                <text-box type="text" label="Font size" 
                    @change="${e => (tempSize = e.currentTarget.value)}"
                    .value="${tempSize}"></text-box>
                <text-box type="text" label="Text" 
                    @change="${e => (tempText = e.currentTarget.value)}"
                    .value="${tempText}"></text-box>
                <div class="cPick">
                    <label for="tColor">Text color</label>
                     <color-picker id="tColor" name="lColor" .value="${tempColor}" @change="${(e) => tempColor = e.detail}" ></color-picker>
              
				</div>
            </div>

            <div class="button-box">
                <mwc-button @click="${closeFunc}" label="Close"></mwc-button>
                <mwc-button @click="${applyFunc}" label="Apply"></mwc-button>
            </div>`;
	}

	_updateColor() {
		if (this.selectedColor) {
			this.style.setProperty("--selected-color", this.selectedColor);
		}
	}

	constructor(canvas, getColor) {
		super();
		this.__getColor = getColor;
		this.canvas = canvas;

		this.__drawText = (o) => {
			var pointer = this.canvas.getPointer(o.e);
			var txtBoxConfig = {
				fontSize: 25,
				fontFamily: "Arial",
				width: 300,
				left: pointer.x,
				top: pointer.y,
				noScaleCache: true,
				fill: this.__getColor()
			};
			var obj = new fabric.Textbox("", txtBoxConfig);
			this.canvas.add(obj);
			this.addMetadata(obj, { text: obj.text, fontSize: 25, fill: this.__getColor() });
			this.canvas.setActiveObject(obj);

			obj.enterEditing();
			this.canvas.renderAll();
		};

		this.__textObjectChanged = (o) => {
			this.addMetadata(o, { text: o.text });
		};
	}

	applyNewSettings(obj, fontSize, fill, text) {
		const currentSettings = obj.moduleState;
		if (currentSettings.fontSize == fontSize &&
            currentSettings.fill == fill &&
            currentSettings.text == text) return;

		this.addMetadata(obj, { fontSize: Number(fontSize), fill, text });
		obj.set({ fontSize: Number(fontSize), fill, text });

		this.canvas.renderAll();
		obj.exitEditing();
	}
}

window.customElements.define("inspx-draw-text", DrawTextModule);
